import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import translate from '../utils/utils';
const InputText = forwardRef(({ id, error, label, wrapStyle, type = 'text', errorParams, ...otherProps }, ref) => {
    const { t } = useTranslation('shared');
    const translateErrorCode = (err, errorParams) => {
        if (!err)
            return '';
        if (err.type === 'required')
            return t('common.errors.required', errorParams);
        if (err.type === 'test-Sin-type')
            return t('common.errors.number', errorParams);
        return err.message ? translate(err.message, errorParams) : '';
    };
    return (_jsxs("div", { className: `control-group ${error && 'error'}`, children: [label && _jsx("label", { htmlFor: id, children: label }), _jsx("div", { className: wrapStyle, children: _jsx("input", { id: id, type: type, ...otherProps, ref: ref }) }), error && _jsx("p", { className: "error-message", children: translateErrorCode(error, errorParams) })] }));
});
InputText.displayName = 'InputText';
export default InputText;
